export default __webpack_public_path__ + "static/media/instagrad.81563d78.svg";